import { HttpClient } from '@angular/common/http';
import { isPlatformServer, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID, TransferState, makeStateKey } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import * as fs from 'fs';
import * as path from 'path';

@Injectable()
export class TranslateUniversalLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private transferState: TransferState,
    @Inject(PLATFORM_ID) private platformId: any
  ) {}

  getTranslation(lang: string): Observable<any> {
    const key = makeStateKey<any>('transfer-translate-' + lang);
    const existing = this.transferState.get(key, null);

    // Si ya tenemos traducción (desde SSR)
    if (existing) return of(existing);

    // En SSR → leer el archivo JSON directamente del filesystem
    if (isPlatformServer(this.platformId)) {
      try {
        const filePath = path.join(process.cwd(), `dist/browser/assets/i18n/${lang}.json`);
        const file = fs.readFileSync(filePath, 'utf8').replace(/^\uFEFF/, '');
        const jsonData = JSON.parse(file);
        this.transferState.set(key, jsonData);
        return of(jsonData);
      } catch (err) {
        console.error('Error loading translation on server:', err);
        return of({});
      }
    }

    // En navegador → usar HttpClient normalmente
    if (isPlatformBrowser(this.platformId)) {
      return this.http.get(`/assets/i18n/${lang}.json`).pipe(
        tap((translation) => this.transferState.set(key, translation))
      );
    }

    return of({});
  }
}
